import { defineMessages } from 'react-intl';

export default defineMessages({
    SkipNav: {
        id: 'common.navigation.commonComponents.SkipNav',
        defaultMessage: 'Skip help and navigation'
    },
});
